import React, { memo } from 'react'
import { ZIndex } from '@opallabs/gem'
import { Tooltip } from '@opallabs/lapidary'

type MemomizedPopoverProps = {
  label: string
  children: React.ReactElement
}

export const MemoizedPopover = memo<MemomizedPopoverProps>(
  ({ label, children }) => {
    if (React.isValidElement(children)) {
      return (
        <Tooltip
          legacyTheme="dark" // Used because tooltips are currently light on light
          content={label}
          side="top"
          zIndex={ZIndex.Shroud.Tooltip} // Required to appear in legacy places like content composer
          contentStyles={{
            marginBottom: 4,
            display: !label.length ? 'none' : undefined,
          }}
        >
          {children}
        </Tooltip>
      )
    }

    return null
  }
)
MemoizedPopover.displayName = 'MemoizedPopover'
